module.exports = __webpack_public_path__ + "assets/Support.bbd7ba00.svg";